export default __webpack_public_path__ + "static/media/Group 3212@2x.a25d0b9b.png";